var SCM = SCM || {};

(function (ns, $) {

    ns.initCommunicationPreferences = function (defaultClassificationId) {

        if (!$('#communication-preferences').length) {
            return;
        }
        SCM.MyAccount.countSubjectChoices();

        // expand child subjects per main subject click
        $('#communication-preferences-subject-choices').on('click', '.mainSubjects > button', function () {
            ExpandCollapseTreeItem($(this));
        });

        $('.js-pref-tree').on('keydown', function (e) {
            handleArrowKeys(e);
        });

        // subject checkbox click
        $('#communication-preferences-subject-choices').on('click', 'input[type=checkbox]', function () {
            // just in case it has child subjects
            $(this).next('ul').find('input[type=checkbox]').prop('checked', !$(this).is(':checked'));

            SCM.MyAccount.countSubjectChoices(); //for simplicity, just recount the whole tree
        });

        // set the user type specific subjects, e.g. librarian
        // page init
        if (defaultClassificationId != null && defaultClassificationId > 0) {
            $('#communication-preferences #userTypes').val(defaultClassificationId);
        }
        
        SCM.MyAccount.changeUserTypeSubjects(false);

        $('#communication-preferences #userTypes').on('change', function () {
            SCM.MyAccount.changeUserTypeSubjects(true);
        });

        // send an email if checked
        $('#communication-preferences #btnConfirmOptIn').on('click', function () {
            handleOptInChoice($(this));
        });

        // update button
        $('#communication-preferences #updatePreferencesBtn').on('click', function (e) {
            handleUpdatePreferences($(this));
            e.preventDefault();
        });

        //NARN-6431
        $('#communication-preferences #communication-preferences-subject-choices input[type="checkbox"][data-type="subjectId"]').on('click', function () {
            var $container = $('#communication-preferences');
            $container.find('.success-message').hide();
        });
    };

    function ExpandCollapseTreeItem($this) {
        var $parent = $this.parents('.mainSubjects');
        $parent.children('ul').slideToggle();
        var $icon = $parent.find('.js-show-headings-icon');
        $icon.hasClass('icon-general-arrow-filled-down') ?
            $icon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right') :
            $icon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
        $parent.children('.comms-subject-heading-button').attr('aria-expanded', function (i, attr) {
            return attr == 'true' ? 'false' : 'true';
        });
        $parent.find('.screenreader-text').text(function (i, text) {
            return text == 'Collapse' ? 'Expand' : 'Collapse';
        });
        $parent.children('.comms-subject-heading-button').focus();
    }

    function handleOptInChoice($btnConfirmOptIn) {

        $.ajax({
            url: '/OUPMyAccount/SendEmailForOptInCommPref',
            type: 'GET',
            dataType: 'json'
        }).done(function (data) {
            if (data.Success) {
                $('#communication-preferences').find('.success-message').html(data.Html).show();
            } else {
                $('#communication-preferences').find('.error-message').html(data.Html).show();
            }

            $btnConfirmOptIn.hide();
            $('#communication-preferences .send-verify-email').hide();
        });
    }

    function handleUpdatePreferences($this) {

        var $container = $('#communication-preferences');
        var optInMarketEmail = !$container.find('#confirmOptOut').is(':checked');
        var subjectIds = [];
        $container.find('input[type=checkbox][data-type=subjectId]').filter(':checked').each(function (i, checkbox) {
            subjectIds.push($(checkbox).val());
        });
        var classificationId = $container.find('#userTypes').val();
        $.ajax({
            url: '/OUPMyAccount/UpdateCommunicationPreferences',
            type: 'POST',
            traditional: true,
            data: { optInMarketEmail: optInMarketEmail, subjectIds: subjectIds, classificationId: classificationId },
            dataType: 'html'
        }).done(function (data) {
            if (data.includes('apologize')) {
                $container.find('.error-message').html(data).show();
            } else {
                $container.find('.success-message').html(data).show();
            }

            if (optInMarketEmail) {
                $container.find('.optedIn-message').show();
                $container.find('.optedOut-message').hide();
            } else {
                $container.find('.optedIn-message').hide();
                $container.find('.optedOut-message').show();
            }
            // now the choices have been persisted, we should update data-checked attributes for further selections
            $container.find('#userTypeSubjects input[type=checkbox][data-type=subjectId]').each(function (i, checkbox) {
                $(checkbox).data('checked', $(checkbox).is(':checked'));
            });
        });
    }

    function focusNextVisibleItem($focusItem) {
        var $nextFocusItem;
        if ($focusItem.hasClass('js-pref-tree')) {
            var $nextListItem = $focusItem.find('li.mainSubjects:first-child');
            $nextFocusItem = $nextListItem.find('.comms-subject-heading-button');
        }
        else {
            if ($focusItem.is('input')) {
                $nextFocusItem = $focusItem.parent().next('.secondarySubjects').find('input');
                if (!$nextFocusItem.length) {
                    // if we hit the last input, go to next button
                    $nextFocusItem = $focusItem.parents('.mainSubjects').next().find('.comms-subject-heading-button');
                }
            }
            else {
                if (isExpanded($focusItem)) { // find the first input element under the button
                    $nextFocusItem = $focusItem.parent().find('ul li.secondarySubjects:first-child input');
                }
                else {  // go to the next button
                    $nextFocusItem = $focusItem.parents('.mainSubjects').next().find('.comms-subject-heading-button');
                }
            }
        }
        if ($nextFocusItem.length) {
            $nextFocusItem.focus();
        } 
    }

    function focusPreviousVisibleItem($focusItem) {
        var $prevFocusItem;        
        if ($focusItem.is('input')) {
            $prevFocusItem = $focusItem.parent().prev('.secondarySubjects').find('input');
            if (!$prevFocusItem.length) {
                // if we hit the first input, go to parent button
                $prevFocusItem = $focusItem.parents('.mainSubjects').find('.comms-subject-heading-button');
            }
        }
        else {
            $prevFocusItem = $focusItem.parents('.mainSubjects').prev().find('.comms-subject-heading-button');
        }
        if ($prevFocusItem.length) {
            if (!$focusItem.is('input') && $prevFocusItem.is('button') && isExpanded($prevFocusItem)) {
                $prevFocusItem = $prevFocusItem.siblings('ul').children('li:last-child').find('input');
            }
            $prevFocusItem.focus();
        }
    }

    function isExpanded($focusItem) {
        var $expander = $focusItem.is('button') ?
            $focusItem :
            $focusItem.parents('.mainSubjects').find('button.comms-subject-heading-button');
        return $expander.length && $expander.attr('aria-expanded') === 'true';
    }
    
    function handleArrowKeys(e) {
        var $focusItem = $(':focus');
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            focusPreviousVisibleItem($focusItem);
        }

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            focusNextVisibleItem($focusItem);
        }

        if (e.key === 'ArrowRight') {
            e.preventDefault();   
            if (!isExpanded($focusItem)) {
                ExpandCollapseTreeItem($focusItem);
            }
        }

        if (e.key === 'ArrowLeft') {
            e.preventDefault();     
            if (isExpanded($focusItem)) {
                ExpandCollapseTreeItem($focusItem);
            }    
        }
    }

})(SCM.MyAccount = SCM.MyAccount || {}, jQuery);
